import React from 'react';
import useLockScroll from 'hooks/useLockScroll'; // 스크롤 잠금 훅

const PaymentDetailModal = ({isOpen, onClose, data, onCancelSubscription}) => {
    // 모달이 열려있을 때 뒷 배경 스크롤 잠금
    useLockScroll(isOpen);

    if (!isOpen || !data) return null;

    const isSubscription = data.auto === 'Y';

    // 종료일이 오늘 이후인지 확인 (유효한 구독인지)
    const checkActive = (edate) => {
        if (!edate) return false;
        const today = new Date();
        today.setHours(0, 0, 0, 0);

        // edate 포맷: YYYY.MM.DD
        const [year, month, day] = edate.split('.').map(Number);
        const end = new Date(year, month - 1, day);
        end.setHours(0, 0, 0, 0);

        return end >= today;
    };

    // 취소 가능 조건: 구독 상품이면서 종료일이 지나지 않음
    const isCancelable = isSubscription && checkActive(data.edate);

    return (
        <div style={modalStyles.overlay} onClick={onClose}>
            <div style={modalStyles.content} onClick={(e) => e.stopPropagation()}>
                <h3 style={modalStyles.title}>결제 상세 정보</h3>

                <div style={modalStyles.infoGrid}>
                    <InfoRow label="상품명" value={data.productName}/>
                    <InfoRow label="지점명" value={data.branchName}/>
                    <InfoRow label="결제 금액" value={data.price}/>
                    <InfoRow label="결제일" value={data.date}/>
                    <InfoRow label="구독 여부" value={isSubscription ? '구독 상품' : '구독 취소'}/>

                    {isSubscription && (
                        <>
                            <InfoRow label="구독 시작일" value={data.sdate}/>
                            <InfoRow label="구독 종료일" value={data.edate}/>
                        </>
                    )}
                </div>

                <div style={modalStyles.buttonGroup}>
                    {/* 유효한 구독일 때만 취소 버튼 표시 */}
                    {isCancelable && (
                        <button
                            style={modalStyles.cancelButton}
                            onClick={() => onCancelSubscription(data)}
                        >
                            구독 취소
                        </button>
                    )}
                    <button style={modalStyles.closeButton} onClick={onClose}>
                        닫기
                    </button>
                </div>
            </div>
        </div>
    );
};

// 내부 정보 행 컴포넌트
const InfoRow = ({label, value}) => (
    <div style={modalStyles.row}>
        <span style={modalStyles.label}>{label}</span>
        <span style={modalStyles.value}>{value}</span>
    </div>
);

// 스타일
const modalStyles = {
    overlay: {
        position: 'fixed', top: 0, left: 0, right: 0, bottom: 0,
        backgroundColor: 'rgba(0,0,0,0.6)', zIndex: 2000,
        display: 'flex', justifyContent: 'center', alignItems: 'center'
    },
    content: {
        background: '#1B1931', width: '320px', padding: '24px', borderRadius: '12px',
        color: '#FFFFFF', boxShadow: '0 4px 20px rgba(0,0,0,0.5)',
        boxSizing: 'border-box'
    },
    title: {
        fontSize: '18px', fontWeight: 'bold', marginBottom: '20px', textAlign: 'center', color: '#FCFCFA',
        fontFamily: 'Pretendard'
    },
    infoGrid: {display: 'flex', flexDirection: 'column', gap: '12px', marginBottom: '24px'},
    row: {display: 'flex', justifyContent: 'space-between', borderBottom: '1px solid #3A394A', paddingBottom: '8px'},
    label: {color: '#9A9A9A', fontSize: '14px', fontFamily: 'Pretendard'},
    value: {color: '#FCFCFA', fontSize: '14px', fontWeight: '500', fontFamily: 'Pretendard'},
    buttonGroup: {display: 'flex', gap: '10px'},
    cancelButton: {
        flex: 1, padding: '12px', borderRadius: '8px', border: '1px solid #FF5252',
        background: 'transparent', color: '#FF5252', cursor: 'pointer', fontWeight: 'bold',
        fontFamily: 'Pretendard'
    },
    closeButton: {
        flex: 1, padding: '12px', borderRadius: '8px', border: 'none',
        background: '#3A394A', color: '#FFFFFF', cursor: 'pointer', fontWeight: 'bold',
        fontFamily: 'Pretendard'
    }
};

export default PaymentDetailModal;